import { useMutation } from "react-query";
import { getSubmittedInvoiceById } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetSubmittedInvoiceById = () => {
  return useMutation(getSubmittedInvoiceById);
};
